<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/qkKRLD/tc-custom/9781680571288.jpg?1734031081969" alt="This image is the cover for the book Drumbeats"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Drumbeats
      </h1>
      <p class="bookDescription body article font2">
        <b>This dark fantasy set in Africa is a collaboration between a <i>New York Times</i>–bestselling author and the drummer from the multi-platinum rock band, Rush.</b><br/>  <br/> A chilling tale of African drums and human souls from #1 international bestselling author Kevin J. Anderson and legendary Rush lyricist and drummer Neil Peart.<br/><br/> Early in their three decades of correspondence, Neil Peart sent Kevin J. Anderson extensive descriptions and travelogues of his adventures bicycling solo across Africa. Peart painted a vivid and unsettling landscape as memorable as the lyrics to his songs.<br/><br/> Anderson, award-winning and bestselling fantasy and science fiction author, used those descriptions as the backdrop for plotting an intense, atmospheric dark fantasy story that followed Peart’s experiences, though with a much more ominous twist. The two used their respective strengths to weave a memorable tale that will linger long after the last page.<br/><br/> This special illustrated edition includes Anderson’s new introduction, written after Peart’s death on January 7, 2020, as well as the original Afterword Peart wrote for the story. 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kevin J. Anderson, Neil Peart
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?14890693